import React, { useEffect, useState } from 'react'
import ApiRequest from '../Common/restservice';
import { useNavigate } from 'react-router-dom';
import { errorToast, successToast } from '../Common/showtoast';
import Swal from 'sweetalert2';

function Withdraw() {
    const navigate = useNavigate();
    const [tableData, setTableData] = useState([]);
    const [payoutwallet, setpayoutwallet] = useState([]);
    const [walletaddress, setWalletaddress] = useState("");
    const [amount, setAmount] = useState("");
    useEffect(() => {
        GetTransactions();
        GetDashboardDetails();
    }, [])
    const GetTransactions = async () => {
        let res = await ApiRequest("WithdrawalReport.asp", "GET", null, { Authorization: localStorage.getItem("token") });
        console.log(res);
        if (res.status === "error") {
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        setTableData(res.items);
    }
    const GetDashboardDetails = async () => {
        let res = await ApiRequest("GetDashboardDetails.asp", "GET", null, { Authorization: localStorage.getItem("token") });
        if (res.status === "error") {
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        setpayoutwallet(res.availablePaywallet);
    }
    const withdrawConfirm = async (json) => {
        let res = await ApiRequest("WidthdrawalRequest.asp", "POST", json, { Authorization: localStorage.getItem("token") });
        if (res.status === "error") {
            errorToast(res.message);
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        successToast(res.message);
        // setWalletaddress("");
        setAmount("")
        GetDashboardDetails();
        GetTransactions();
    }
    return (
        <section className='content'>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
                    <div className="card overflow-hidden dash1-card border-0 ">
                        <div className="card-body">
                            <h3 className=" mt-3 mb-3 text-center">Withdraw</h3>
                            <h5 className=" mt-3 mb-3 text-center">Withdrawal Process will take 24 hours, Please be patient.</h5>
                            <div className="col-lg-12 row mt-2">
                                <label className="col-lg-6 col-md-12 col-form-label mt-2" type="button">Income Wallet Balance</label>
                                <h6 className="col-lg-6 col-md-12 mt-2 text-center">Rs. {payoutwallet||0}</h6>
                                <label className="col-lg-6 col-md-12 col-form-label mt-2" type="button">Amount to withdraw</label>
                                <div className='col-lg-6 col-md-12' >
                                    <input type="text" className=" form-control mt-2" placeholder="Please enter amount" aria-label="Amount" tabIndex="1" value={amount} onChange={(e) => {
                                        setAmount(e.target.value)
                                    }} />
                                </div>
                                {/* <label className="col-lg-6 col-md-12 col-form-label mt-2" type="button">Wallet Address (BEP20)</label>
                                <div className='col-lg-6 col-md-12' >
                                    <input type="text" className=" form-control mt-2" placeholder="Please enter bep20 wallet address" aria-label="Amount" tabIndex="1" value={walletaddress} onChange={(e) => {
                                        setWalletaddress(e.target.value)
                                    }} />
                                </div> */}
                            </div>
                            <div className="col-lg-12 col-md-12 text-center" >
                                <button className="btn btn-primary mt-5" onClick={async (e) => {
                                    // if (!walletaddress || Number(walletaddress)) {
                                    //     errorToast("Enter valid address");
                                    //     return;
                                    // } else 
                                    if (!amount) {
                                        errorToast("Enter valid amount");
                                        return;
                                    }
                                    // let res = await ApiRequest("WidthdrawalConfirm.asp", "POST", {
                                    //     amount: amount,
                                    //     walletaddress: walletaddress
                                    // }, { Authorization: localStorage.getItem("token") });
                                    // console.log(res);
                                    // if (res.status === "error") {
                                    //     errorToast(res.message);
                                    //     if (res.message === "Session Expired") {
                                    //         localStorage.clear();
                                    //         navigate("/login");
                                    //     }
                                    //     return;
                                    // }
                                    // successToast(res.message);
                                    const { value: tac } = await Swal.fire({
                                        title: 'Please enter your login password to continue',
                                        input: 'password',
                                        inputLabel: 'Your login password',
                                        inputPlaceholder: 'Enter your login password',
                                        showCancelButton: true,
                                        inputValidator: (value) => {
                                            if (!value) {
                                                return 'Please enter your login password or cancel!'
                                            }
                                        }
                                    })
                                    if (!tac) {
                                        return;
                                    }
                                    var t = {
                                        amount: amount,
                                        // walletaddress: walletaddress,
                                        tac: tac,
                                        OTP:tac
                                    };
                                    await withdrawConfirm(t)
                                }}>Withdraw</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-3">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-3" style={{ fontWeight: "200", fontSize: "22px" }}>Withdraw History</h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top" style={{ textAlign: "center" }}>
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>Rs.</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            tableData.length <= 0 ? <tr>
                                                <td colSpan="4">No Details Found</td>
                                            </tr> :
                                                tableData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{(index + 1)}</td>
                                                        <td>{item.cdate}</td>
                                                        <td>{item.in_usd}</td>
                                                        <td>{item.status}</td>
                                                    </tr>
                                                ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    )
}

export default Withdraw
